/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import http from "@/http";
import * as types from "./types";
import { patternMakerData } from '@/data/modelsData';

const actions = {
  [types.CREATE_PATTERN](
    context,
    { componentName, swatch_id, sticker_id, size, model, type = "customizer" }
  ) {

    const params = {
      component: componentName,
      model,
      size,
      swatch_id,
      sticker_id
    };

    return http
      .get(context.rootState.endPoints[type].checkerboard, { params })
      .then(({ data }) => {
        const swatchData = context.rootState.utils.availableSwatches.find(
          e => Number(e.id) === Number(swatch_id)
        );
        const { stitch_color: tonal_stitch_color } = swatchData;
        const {
          original_image,
          placements,
          size,
          ugc_swatch,
          ugc_swatch_id
        } = data;
        return Promise.resolve({
          data: {
            ugc: {
              original_image,
              placements,
              size,
              ugc_swatch,
              tonal_stitch_color
            },
            swatch_id: ugc_swatch_id
          },
          componentName
        });
      });
  },
  [types.LOAD_PATTERNMAKER_SWATCHES]({ rootState, commit }, swatches) {
    const endpointUrl = rootState.endPoints.patternmaker.availableSwatches + swatches.join(',');

    return new Promise ((resolve, reject) => {
      http
        .get(endpointUrl)
        .then(({ data }) => {
          const filteredSwatches = swatches.map(item => data[item]);

          commit('utils/SET_AVAILABLE_SWATCHES', filteredSwatches, { root: true });
          resolve(swatches);
        })
        .catch(reject);
    });
  },
  /**
   * Get selectable Styles.
   * TODO update with API
   */
  [types.FETCH_PRODUCT_DATA]() {
    return new Promise(resolve => {
      resolve(patternMakerData);
    });
  },

  [types.GET_RESULTING_IMAGE](context, { swatchId, stickerId = null }) {
    return new Promise((resolve, reject) => {
      if (!swatchId) reject("Swatch id is required");
      const params = {
        swatch_id: swatchId,
      };
      if (stickerId)  params.sticker_id = stickerId;
      http
        .get(context.rootState.endPoints.patternmaker.patternmaker, { params })
        .then(({ data }) => resolve(data))
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  },
  [types.GET_SVG_RENDERER_IMAGE]({ rootState }, { swatchId, stickerId, size, modelUrl }) {
    let url = `${rootState.endPoints.patternmaker.checkerboard}?size=${ size }&swatch_id=${ swatchId }&${ modelUrl }`;
    if (!!stickerId) {
      url += `&sticker_id=${ stickerId }`
    }

    return http
      .get(url)
      .then(({ data }) => data)
      .catch(console.error);
  },
};

export default actions;
